export default "__VITE_ASSET__DExwD57O__"